import React, { Component } from 'react';

class DashCatego extends Component {
    constructor(props) {
        super(props);
      
    }
    render() {
        return (
            <div className='dash__headers'>
            <div className="bienvenu__head d-flex align-items-center">
              <h2 className="bienvenu__txt">{this.props.name}</h2>
              
            </div>
            <hr className='ddd'/>
            </div>
        );
    }
}

export default DashCatego;